import Dropdown from "react-bootstrap/Dropdown";
import DropdownToggle from "react-bootstrap/DropdownToggle";
import DropdownMenu from "react-bootstrap/DropdownMenu";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function Component({ children, icon, label, fullWidth, isOpen, setIsOpen, menuProps, buttonProps, onEnter, onExit }) {

  const onClick = () => {
    setIsOpen(true);
  }

  const renderToggle = () => {
    return (
      <DropdownToggle variant="light" {...buttonProps} onClick={onClick}>
        <div className="d-flex flex-row gap-1 flex-nowrap align-items-center">
          {icon && <FontAwesomeIcon icon={icon} />}
          {label}
        </div>
      </DropdownToggle>
    );
  }

  const renderMenu = () => {
    return (
      <DropdownMenu {...menuProps}>
        {children}
      </DropdownMenu>
    );
  }

  const onToggle = (nextShow) => {
    if (nextShow === false) {
      setIsOpen(false);
      if (typeof onExit === "function") {
        onExit();
      }
    }
    if (nextShow === true) {
      if (typeof onEnter === "function") {
        onEnter();
      }
    }
  }

  return (
    <Dropdown autoClose={true} onToggle={onToggle} show={isOpen} >
      {renderToggle()}
      {renderMenu()}
    </Dropdown>
  );

}
